/** Same Plasmic component id as former Hamdast bimehnama widget. */
export const BIMEHNAMA_WIDGET_ID = 'hhhzbbsffq0nlna';
export const BIMEHNAMA_APP_KEY = 'bimehnama';

export type BikoPublicInsuranceItem = {
  name: string;
  key: string;
  icon: string;
};

/** Enriched public shape — matches former bimehnama /api/data for PlasmicHamdastBimehnamaWidget. */
export type BikoPublicInsuranceData = {
  base?: BikoPublicInsuranceItem[];
  supplement?: BikoPublicInsuranceItem[];
  updated_at?: string | null;
};

export function isHamdastBimehnamaWidget(widget: { app?: string; id?: string } | null | undefined): boolean {
  if (!widget) return false;
  return widget.app === BIMEHNAMA_APP_KEY || widget.id === BIMEHNAMA_WIDGET_ID;
}

export function hasBikoInsuranceDisplayData(data: unknown): boolean {
  if (!data || typeof data !== 'object') return false;
  const row = data as BikoPublicInsuranceData;
  const baseLen = Array.isArray(row.base) ? row.base.length : 0;
  const supplementLen = Array.isArray(row.supplement) ? row.supplement.length : 0;
  return baseLen > 0 || supplementLen > 0;
}

/** Drop legacy Hamdast bimehnama widgets — display now comes from Biko. */
export function withoutHamdastBimehnamaWidgets<T extends { app?: string; id?: string }>(
  widgets: T[] | null | undefined,
): T[] {
  if (!Array.isArray(widgets)) return [];
  return widgets.filter(widget => !isHamdastBimehnamaWidget(widget));
}

export function resolveBikoInsuranceForProfile(
  fromProps: BikoPublicInsuranceData | null | undefined,
  fromQuery: BikoPublicInsuranceData | null | undefined,
): BikoPublicInsuranceData | null {
  if (hasBikoInsuranceDisplayData(fromQuery)) return fromQuery!;
  if (hasBikoInsuranceDisplayData(fromProps)) return fromProps!;
  return null;
}
